import { Component } from '@angular/core';

@Component({
  selector: 'app-fix-left-section',
  templateUrl: './fix-left-section.component.html',
  styleUrl: './fix-left-section.component.scss'
})
export class FixLeftSectionComponent {

}
